import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const ReferrerRewardPlan = React.lazy(() =>
    import('../ReferrerRewardPlan')
);
const referrerRewardPlanRoutesRegistry = [
    {
        path: PAGE_URL.REFERRER_REWARD_PLAN_PAGE,
        element: <ReferrerRewardPlan />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default referrerRewardPlanRoutesRegistry;
